const IS_DEV =
  process.env.NODE_ENV === 'development' ||
  process.env.KAE_ENVIRONMENT === 'beta'

const isPrivate = process.env.VUE_APP_IS_PRIVATE
const isPriDocMiddle: boolean = process.env.VUE_APP_DEPLOY_ENVIRONMENT === 'private_doc'
const pathArr = location.pathname.split('/')
pathArr.pop()
export const priSubPath = pathArr.join('/')
export const ACCOUNT_URL = isPrivate ? `${priSubPath}/account/?cb=` : 'https://account.wps.cn/?cb='
export const OPEN_URL = '/'
export const USER_CENTER_URL = 'https://account.wps.cn/usercenter'
export const WPS_OFFICE = 'http://2019.docer.com/'
export const WPS_DOCS = 'https://docs.wps.cn/'
export const OPEN_DOCS = isPrivate ? isPriDocMiddle ? '#/docs/middle-app' : '#/docs/enterprise-inner-app/app-config' : '/docs/cloud'
export const OPEN_AGREEMENT = isPrivate ? '#/agreement' : '/agreement'
export const OPEN_PLUS_WPS = 'https://plus.wps.cn/'
export const WPS = 'http://www.wps.cn/'
export const OPEN_API = 'https://openapi.wps.cn/'
export const FEEDBACK = 'https://f.wps.cn/form-write/Q7ksiCYC/'
export const WWO_DOCS = 'https://wwo.wps.cn/docs/'
// export const PROTOCOL_URL = '/protocol.html'
export const PROTOCOL_URL = isPrivate ? '#/agreement' : '/agreement'
export const MOBILE_URL = '/mobile.html'
export const PRIVACY_URL = 'http://www.wps.cn/privacy/privacyprotect/'
export const PRIVACY_ACCOUNT_URL = 'http://www.wps.cn/privacy/account/'
export const EP_URL = 'https://ep.wps.cn/'
export const APP_CENTER_URL = 'https://open-mobapp.wps.cn/app/#/home'

// 开发文档
export const CLOUD_DOC_URL = isPrivate ? isPriDocMiddle ? '#/docs/middle-app' : '#/docs/enterprise-inner-app' : '/docs/cloud'
export const IP_URL = '/docs/cloud/join/ip-list'
export const DOMAIN_URL = '/docs/cloud/join/domain-list'
export const CALLBACK_URL =
  '/docs/cloud/join/callback-address'
export const WEBOFFICE_DOC_URL = '/docs/wwo'
export const TRANSFORM_DOC_URL = '/docs/doc-format-conversion'
// eslint-disable-next-line
export const priUrlReg = "(ht|f)tp(s?)\:\/\/[0-9a-zA-Z]([-.\w]*[0-9a-zA-Z])*(:(0-9)*)*(\/?)([a-zA-Z0-9\-\.\?\,\'\/\\\+&amp;%\$#_]*)?"

const FUNCTION_ID_MAP_PRODUCTION = {
  账号授权: 1904030916507656,
  企业通讯录: 2007011613596820,
  企业内部授权: 2007011614221160,
  文档协同管理开放能力: 0
}

const FUNCTION_ID_MAP_BETA = {
  账号授权: 1812251648585076,
  企业通讯录: 1909261646148393,
  企业内部授权: 2005131114025739,
  文档协同管理开放能力: 0
}

const FUNCTION_ID_MAP_PRIVATE = {
  账号授权: 0,
  企业通讯录: 0,
  企业内部授权: 2011260119277637,
  文档协同管理开放能力: 2011051538011727
}

// 应用能力
export const FUNCTION_ID_MAP = isPrivate ? FUNCTION_ID_MAP_PRIVATE : IS_DEV
  ? FUNCTION_ID_MAP_BETA
  : FUNCTION_ID_MAP_PRODUCTION

export const APP_TOPIC_MAP = [{
  name: '企业成员变更消息',
  keys: ['wps.open.plus.member.status', 'wps.open.plus.member']
}, {
  name: '企业部门变更消息',
  keys: ['wps.open.plus.dept']
}, {
  name: '企业变更消息',
  keys: ['wps.open.plus.company']
}, {
  name: '日历消息推送',
  keys: ['wps.open.calendar']
}]
export const CORP_AUTH_NOTIFY_DOC_URL = '/docs/cloud/basic-ability/app-oauth/oauth-change'
export const PAY_DOC_URL = '/docs/cloud/basic-ability/wps-pay/quick-access'
export const WEBOFFICE_API_DOC_URL = '/docs/wwo/access/api-list'
export const ACCESS_KNOW_URL = '/docs/cloud/basic-ability/account-oauth/access-know'
export const PAY_CALLBACK_ARG = '/docs/cloud/FAQ#des10'
export const PAY_CALLBACK_URL = '/docs/cloud/basic-ability/wps-pay/api-list#des7'

export const RSA_TAIL_KEY = 'cE1heURwTlRMTjBrVUxreHBTbWNoMDFPb3NObnNtUHFEWThRemRRSkRESnA0VEhyVG1HCmdzVUY2ZVNQSEtEOTVaK1lpMVAxcmVBKzVCMTFhODRMYVNFWmVnMTJ4eElXanhkczhRQ3ExUDlVdmU1RXdPS0oKalFJREFRQUIKLS0tLS1FTkQgUFVCTElDIEtFWS0tLS0t'
